import type { ReactNode } from "react"

import ImpersonationBanner from "@/components/impersonation-banner"
import { Toaster } from "@/components/ui/sonner"
import { useFlash } from "@/hooks/use-flash"
import { useTimezoneDetection } from "@/hooks/use-timezone-detection"

interface PersistentLayoutProps {
  children: ReactNode
}

export default function PersistentLayout({ children }: PersistentLayoutProps) {
  useFlash()
  useTimezoneDetection()
  return (
    <>
      <ImpersonationBanner />
      {children}
      <Toaster richColors />
    </>
  )
}
